import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Alert } from '@opendate-app/setlist';
import PayForm from './PayForm';

const stripeCache = new Map();

export const stripeFor = (publishableKey, connectedAccountId) => {
  const cacheKey = `${publishableKey}:${connectedAccountId || ''}`;
  if (!stripeCache.has(cacheKey)) {
    stripeCache.set(
      cacheKey,
      connectedAccountId ? loadStripe(publishableKey, { stripeAccount: connectedAccountId }) : loadStripe(publishableKey)
    );
  }
  return stripeCache.get(cacheKey);
};

const Payment = ({ publishableKey, connectedAccountId, clientSecret, appearance, label, returnUrl, onPaid, onLockChange, elementOptions }) => {
  const stripePromise = useMemo(
    () => (publishableKey ? stripeFor(publishableKey, connectedAccountId) : null),
    [publishableKey, connectedAccountId]
  );

  if (!publishableKey || !clientSecret) {
    return <Alert color="warning" title="Card payments aren't available in this environment." />;
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
      <PayForm clientSecret={clientSecret} label={label} returnUrl={returnUrl} onPaid={onPaid} onLockChange={onLockChange} elementOptions={elementOptions} />
    </Elements>
  );
};

Payment.propTypes = {
  publishableKey: PropTypes.string,
  connectedAccountId: PropTypes.string,
  clientSecret: PropTypes.string,
  appearance: PropTypes.object,
  label: PropTypes.string,
  returnUrl: PropTypes.string.isRequired,
  onPaid: PropTypes.func.isRequired,
  onLockChange: PropTypes.func,
  elementOptions: PropTypes.object,
};

Payment.defaultProps = {
  publishableKey: null,
  connectedAccountId: null,
  clientSecret: null,
  appearance: undefined,
  label: 'Pay now',
  onLockChange: null,
  elementOptions: undefined,
};

export default Payment;
